import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { parseDateToDDMMYYYY2, validInitDates } from "../../../../helpers/dateTransform";
import "./Information.scss";
import { Box, Stack, Typography, useTheme } from "@mui/material";

export const Complements = ({ complements }) => {

  const [t] = useTranslation("information");
  const theme = useTheme();
  const [comentaries, setComentaries] = useState([]);

  useEffect(() => {
    if (Array.isArray(complements)) {
      const newComentaries = complements.map(item => ({ commentary: item.commentary, created_at: item.created_at }))
      setComentaries(newComentaries);
    }
  }, [complements]);

  return (
    <Box padding="6px 8px 8px">
      <Stack spacing={1}>
        {comentaries.map((item, i) => (
          <Box key={i} borderBottom={`1px solid ${theme.palette.blueGray200.main}`}>
            <Typography display="inline" color="primary" fontWeight={600} fontSize={12} component="span">
              <Typography display="inline" color="blueGray700" fontWeight={600} fontSize={12}>
                {t("complements.added_at")}
              </Typography>
              {validInitDates(item.created_at) ? parseDateToDDMMYYYY2(item.created_at) : String(item.created_at)}
            </Typography>
            <Typography fontSize={16} color="oxfordBlue">
              {item.commentary}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};